module.exports = __webpack_public_path__ + "img/SRB.58fe1664.svg";